module.exports = "<div class=\"m-size-image-animate\" :class=\"className\">\r\n    <div class=\"bg\" :style=\"{background: 'linear-gradient('+bgColor+','+(bgColorDown&&(bgColorDown!='#000000')?bgColorDown:bgColor)+')', width: bgWidth}\"></div>\r\n    <div class=\"image\" :style=\"imageStyle\"></div>\r\n    <img :src=\"image1 | fnjiImage(imageOptions)\">\r\n    <img :src=\"image2 | fnjiImage(imageOptions)\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/component/size-image-animate.html
// module id = 247
// module chunks = 0